var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "gradient-background" }),
    _vm.isLoaded
      ? _c(
          "div",
          { staticClass: "dashboard-wrapper" },
          [
            _c("DashboardBanner", {
              staticClass: "pt-7",
              attrs: { isMobile: _vm.isMobile }
            }),
            _c("DashboardPripady")
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }